import React, { Fragment } from 'react';
import { Button, Alert } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import moment from "moment";

import '../styles/Information.css';

const Information = (props) => {
  const { periods } = props;
  const now = moment();

  const periodIsComplete = (period) => {
    function validDate(date) {
      return date && moment(date).isValid();
    }

    return validDate(period.applicationStartDate) &&
      validDate(period.applicationEndDate) &&
      validDate(period.notificationDate) &&
      validDate(period.documentationDate) &&
      validDate(period.rankingDate) &&
      validDate(period.decisionDate);
  };

  const currentPeriods = periods.filter(period => {
    return periodIsComplete(period) &&
      now.isSameOrAfter(period.applicationStartDate, 'day') &&
      now.isBefore(period.decisionDate, 'day');
  });

  const upcomingPeriods = periods.filter(period => {
    return periodIsComplete(period) &&
      now.isBefore(period.applicationStartDate, 'day')
  });

  const getButton = (period) => {
    const { user, userSet, newUser } = props;
    let currentApplication;
    if(user)
      currentApplication = user.applications.find((application) => period.periodId === application.periodId);
    return userSet || newUser ?
      currentApplication ?
        currentApplication.status === "IN" && now.isBefore(period.applicationEndDate) ?
          (
            <LinkContainer to={`/form/${currentApplication.periodId}`}>
              <Button bsStyle="primary">Continue Application</Button>
            </LinkContainer>
          )
          :
          (
            <LinkContainer to={`/application/${currentApplication.periodId}`}>
              <Button bsStyle="primary">View Application Status</Button>
            </LinkContainer>
          )
        :
        now.isBefore(period.applicationEndDate) ?
          (
            <LinkContainer to={`/create/${period.periodId}`}>
              <Button>Apply Now</Button>
            </LinkContainer>
          )
          :
          (
            <Button disabled>Application Period Closed</Button>
          )
      :
      (
        <Button>Logging In...</Button>
      )
  };

  return (
  <div>
    <h1>Health Sciences Applications</h1>
    <p className="lead">Welcome to the SJDC Health Sciences Admissions Application System</p>
    <p>
      Below you will find any current and future admissions periods. When an admission period becomes active, you will be able to apply
      for admissions to the respective program. Admissions requirements and selection criteria can be found on the {' '}
      <a href="https://deltacollege.edu/academics/academic-divisions/health-sciences-division/registered-nursing/associate-degree-nursing" target="_blank" rel="noopener noreferrer">Health Sciences Department</a> website.
    </p>
    {props.isAuthenticated ?
      <p>
        You can view the current status of any <Link to="/applications">previously submitted applications</Link>.
      </p>
      :
      <p>
        Please Log In above to view the status of any previously submitted applications.
      </p>
    }

    <Alert bsStyle="warning">
      <p>
        <strong>Attention:</strong> Before you begin an application, you must have your Delta College Student ID number and Delta College student e-mail address.
        All correspondence from the college regarding your application will be sent to your Delta College e-mail address.
      </p>
    </Alert>
    <h2>Active Application Periods</h2>
    {currentPeriods.map((period) => (
      <div key={period.periodId}>
        <h3>{period.name} <small>{period.programId}</small></h3>
        {period.note &&
          <div>
            {period.note.split("|").map((i, key) => {
              return <p key={key}><strong><em>{i}</em></strong></p>;
            })}
          </div>
        }
        <p>The {period.programId} application for {period.name} is open from <strong>{moment(period.applicationStartDate).format('MM/DD/YYYY')}</strong> until <strong>{moment(period.applicationEndDate).format('MM/DD/YYYY')}</strong></p>
        {props.isAuthenticated ?
          getButton(period)
          :
          <Alert bsStyle="warning">
            <p>
              You must log in to begin a health sciences application.
            </p>
          </Alert>
        }
      </div>
      )
    )}
    {upcomingPeriods.length > 0 &&
    <Fragment>
      <hr/>
      <h2>Upcoming Application Periods</h2>
      {upcomingPeriods.map((period) => (
          <div key={period.periodId}>
            <h3>{period.name}
              <small>{period.programId}</small>
            </h3>
            {period.note &&
                <div>
                  {period.note.split("|").map((i, key) => {
                    return <p key={key}><strong><em>{i}</em></strong></p>;
                  })}
                </div>
            }
            <p>The {period.programId} application for {period.name} is open
              from <strong>{moment(period.applicationStartDate).format('MM/DD/YYYY')}</strong> until <strong>{moment(period.applicationEndDate).format('MM/DD/YYYY')}</strong>
            </p>
          </div>
        )
      )}
    </Fragment>
    }
  </div>
)};

export default Information;